import React, { useState, useCallback, useEffect } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { ReactComponent as SearchIcon } from "../../../../public/shared/Search-icon.svg";
import "./styles.scss";
import qs from "qs";
import _ from "lodash";

export default () => {
  let location = useLocation();
  let { q } = qs.parse(location.search, {
    ignoreQueryPrefix: true
  });
  let [query, setQuery] = useState(q || "");

  const queryChangehandler = useCallback(
    _.debounce(value => setQuery(value), 500)
  );
  const onChangeSearchQuery = ({ target: { value } }) =>
    queryChangehandler(value);

  useEffect(() => {
    if (q === query) setQuery(q);
  }, [q, query]);

  return (
    <div className="search-bar d-flex align-items-center m-4 bg-dark">
      {query ? (
        <Redirect to={`/browse?q=${query}`} />
      ) : (
        location.pathname === "/browse" && <Redirect to={`/browse`} />
      )}
      <label htmlFor="search-query" className="m-0">
        <SearchIcon className="search-icon" />
      </label>
      <input
        className="ml-2 w-100 bg-dark text-white"
        type="text"
        placeholder="Search"
        defaultValue={query}
        onChange={onChangeSearchQuery}
        id="search-query"
        name="search"
      />
    </div>
  );
};
